import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom-v5-compat';

import config from '@/config';
import { forwardParamsToExtension, isExtensionOAuthResult } from '@/modules/auth/services/oauth/forwardParamsToExtension';
import { parseRedirectUrl } from '@/modules/auth/services/oauth/parseRedirectUrl';

/**
 * If current page is the Google OAuth redirect page and the result is from the extension,
 * forward the result to the extension.
 */
export function useHandleExtensionLogin() {
    const { pathname, search } = useLocation();

    return useQuery({
        queryKey: ['oAuthResultFromExtension', search],
        queryFn: async () => {
            const params = parseRedirectUrl(search);

            await forwardParamsToExtension(params);
        },
        enabled: pathname === config.googleOAuth.redirectUrl && isExtensionOAuthResult(search),
    });
}
